import { LOCALE_ID, NgModule, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app';
import { appInitializer } from '../services/app-initializer.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutsModule } from '../layouts/layouts.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { CacheBustTranslateLoader } from '../services/translate/translate-loader';
import { MyMissingTranslationHandler } from '../services/translate/missing-translation-handler';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfigService, provideConfig } from 'src/services/json-config.service';
import { registerLocaleData } from '@angular/common';
import { OauthModule } from 'src/modules/oauth.module';
import localeCs from '@angular/common/locales/cs';
import dayjs from 'dayjs';
import { provideNgIdle } from '@ng-idle/core';
import { nativeValidVersionInterceptor } from 'src/interceptors/native-valid-version.interceptor';
import {
  provideTranslateService,
  provideMissingTranslationHandler,
  TranslateLoader,
  TranslatePipe,
} from '@ngx-translate/core';
import { refreshInterceptor } from 'src/interceptors/refresh.interceptor';

dayjs.locale('cs');
registerLocaleData(localeCs);

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot([], {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
      paramsInheritanceStrategy: 'emptyOnly',
    }),
    LayoutsModule,
    OauthModule,
    AngularSvgIconModule.forRoot(),
    TranslatePipe,
],
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([
      nativeValidVersionInterceptor,
      refreshInterceptor,
    ])),
    appInitializer,
    provideConfig(),
    ConfigService,
    provideNgIdle(),
    { provide: LOCALE_ID, useValue: 'cs' },
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: () => new CacheBustTranslateLoader(),
      },
      missingTranslationHandler: provideMissingTranslationHandler(MyMissingTranslationHandler),
      fallbackLang: 'cs_bwm', // todo - should not be static/handle liberro
    }),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
